/**
 * Vista: Lista de Requisiciones de Compra
 *
 * Módulo para gestionar el flujo de requisiciones:
 * - Crear nueva requisición
 * - Listar requisiciones
 * - Aprobar/Rechazar requisiciones
 * - Ver detalle
 *
 * MEJORA: Cards colapsables para tractores con formulario en un solo paso
 * MEJORA: Botón eliminar movido al final del body para evitar eliminaciones accidentales
 * MEJORA: Recuadro visual para sección "Seleccionar Modelo"
 * MEJORA: Secciones con borde izquierdo azul para mejor distinción visual
 */

import router from '../router/router.js';
import modeloService from '../services/modelo.service.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header">
          <h2 class="card-title">📋 Requisiciones de Compra</h2>
          <div>
            <button class="btn btn-primary" onclick="window.requisicionesView.mostrarModalCrear()">
              ➕ Nueva Requisición
            </button>
          </div>
        </div>

        <!-- Estadísticas -->
        <div id="statsContainer" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: #fff3cd; padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statPendientes" style="font-size: 2rem; font-weight: bold;">0</div>
            <div style="color: #856404;">Pendientes</div>
          </div>
          <div class="stat-card" style="background: #cce5ff; padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statRevision" style="font-size: 2rem; font-weight: bold;">0</div>
            <div style="color: #004085;">En Revisión</div>
          </div>
          <div class="stat-card" style="background: #d4edda; padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statAprobadas" style="font-size: 2rem; font-weight: bold;">0</div>
            <div style="color: #155724;">Aprobadas</div>
          </div>
          <div class="stat-card" style="background: #d1ecf1; padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statOrdenGenerada" style="font-size: 2rem; font-weight: bold;">0</div>
            <div style="color: #0c5460;">Con OC</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="filtroEstado" class="form-select">
              <option value="">Todos</option>
              <option value="pendiente">Pendiente</option>
              <option value="revision">En Revisión</option>
              <option value="aprobada">Aprobada</option>
              <option value="rechazada">Rechazada</option>
              <option value="orden_generada">Orden Generada</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Prioridad</label>
            <select id="filtroPrioridad" class="form-select">
              <option value="">Todas</option>
              <option value="urgente">Urgente</option>
              <option value="alta">Alta</option>
              <option value="media">Media</option>
              <option value="baja">Baja</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input type="text" id="filtroBusqueda" class="form-input" placeholder="Folio..." />
          </div>
          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.requisicionesView.cargarRequisiciones()" style="width: 100%;">
              🔍 Filtrar
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Folio</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Origen</th>
                <th class="tbl-hide-mobile">Solicitante</th>
                <th class="tbl-hide-mobile">Items</th>
                <th class="tbl-hide-mobile">Prioridad</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="requisicionesTableBody">
              <tr>
                <td colspan="9" style="text-align: center; padding: 2rem;">
                  Cargando requisiciones...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="display: flex; justify-content: center; gap: 0.5rem; margin-top: 1rem;"></div>
      </div>

      <!-- Modal Crear/Editar Requisición -->
      <div id="modalRequisicion" class="modal" style="display: none;">
        <div class="modal-content" style="max-width: 800px;">
          <div class="modal-header">
            <h3 id="modalTitle">Nueva Requisición</h3>
            <button class="modal-close" onclick="window.requisicionesView.cerrarModal()">&times;</button>
          </div>
          <form id="formRequisicion" onsubmit="window.requisicionesView.guardarRequisicion(event)">
            <div class="modal-body">
              
              <!-- Sección: Información General -->
              <div class="modal-section">
                <div class="modal-section-title">Información General</div>
                <div class="req-form-grid">
                  <div class="form-group">
                    <label class="form-label required">Tipo de Origen</label>
                    <select id="tipoOrigen" class="form-select" required>
                      <option value="">Seleccione...</option>
                      <option value="distribuidor">Solicitud de Distribuidor</option>
                      <option value="stock_almacen">Reposición de Stock</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="form-label required">Prioridad</label>
                    <select id="prioridad" class="form-select" required>
                      <option value="media">Media</option>
                      <option value="baja">Baja</option>
                      <option value="alta">Alta</option>
                      <option value="urgente">Urgente</option>
                    </select>
                  </div>
                </div>
                <div class="req-form-grid">
                  <div class="form-group">
                    <label class="form-label">Fecha Requerida</label>
                    <input type="date" id="fechaRequerida" class="form-input" />
                  </div>
                  <div class="form-group" id="distribuidorGroup" style="display: none;">
                    <label class="form-label required">Distribuidor</label>
                    <select id="distribuidorId" class="form-select">
                      <option value="">Seleccione distribuidor...</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Sección: Tractores Solicitados -->
              <div class="modal-section">
                <div class="tractores-header">
                  <div class="tractores-header-left">
                    <span class="modal-section-title" style="margin-bottom: 0;">🚜 Tractores Solicitados</span>
                    <span id="tractoresCount" class="tractores-count">0 unidades</span>
                  </div>
                  <button type="button" class="btn btn-primary" onclick="window.requisicionesView.agregarDetalle()">
                    + Agregar
                  </button>
                </div>
                <div id="detallesContainer">
                  <!-- Se agregan dinámicamente como cards colapsables -->
                </div>
              </div>

              <!-- Sección: Observaciones -->
              <div class="modal-section">
                <div class="modal-section-title">
                  Observaciones <span style="font-weight: normal; color: #94a3b8;">(opcional)</span>
                </div>
                <textarea id="observaciones" class="form-textarea" rows="3" placeholder="Notas adicionales..." style="
                  width: 100%;
                  font-size: 14px;
                  padding: 12px;
                  line-height: 1.5;
                  resize: vertical;
                  border-radius: 8px;
                  border: 1px solid #d1d5db;
                "></textarea>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" onclick="window.requisicionesView.cerrarModal()">Cancelar</button>
              <button type="submit" class="btn btn-primary">💾 Guardar</button>
            </div>
          </form>
        </div>
      </div>

      <!-- Modal Ver Detalle -->
      <div id="modalDetalle" class="modal" style="display: none;">
        <div class="modal-content" style="max-width: 700px;">
          <div class="modal-header">
            <h3>Detalle de Requisición</h3>
            <button class="modal-close" onclick="window.requisicionesView.cerrarModalDetalle()">&times;</button>
          </div>
          <div class="modal-body" id="detalleContent">
            <!-- Contenido dinámico -->
          </div>
          <div class="modal-footer" id="detalleActions">
            <!-- Botones de acción según estado -->
          </div>
        </div>
      </div>

      <!-- Mini-Modal: Crear Modelo Inline -->
      <div id="miniModalModelo" class="modal" style="display: none;">
        <div class="modal-content" style="max-width: 500px;">
          <div class="modal-header">
            <h3>➕ Crear Nuevo Modelo</h3>
            <button class="modal-close" onclick="window.requisicionesView.cerrarMiniModalModelo()">&times;</button>
          </div>
          <form id="formNuevoModelo" onsubmit="window.requisicionesView.guardarNuevoModelo(event)">
            <div class="modal-body">
              <div class="form-group">
                <label class="form-label required">Código</label>
                <input type="text" id="miniModeloCodigo" class="form-input" required placeholder="Ej: M254, 5075E" />
                <small style="color: var(--text-muted);">Código único del modelo</small>
              </div>
              <div class="form-group">
                <label class="form-label required">Nombre del Modelo</label>
                <input type="text" id="miniModeloNombre" class="form-input" required placeholder="Ej: M254, 5075E" />
              </div>
              <div class="form-group">
                <label class="form-label required">Marca</label>
                <select id="miniModeloMarca" class="form-select" required>
                  <option value="">Seleccione...</option>
                  <option value="LOVOL">LOVOL</option>
                  <option value="MAQMUT">MAQMUT</option>
                  <option value="AOSHENG">AOSHENG</option>
                  <option value="OTRO">OTRO</option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">HP (Caballos de Fuerza)</label>
                <input type="number" id="miniModeloHP" class="form-input" min="1" placeholder="Ej: 85" />
              </div>
              <div class="form-group">
                <label class="form-label">Descripción</label>
                <textarea id="miniModeloDescripcion" class="form-input" rows="2" placeholder="Características principales..."></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" onclick="window.requisicionesView.cerrarMiniModalModelo()">Cancelar</button>
              <button type="submit" class="btn btn-success">💾 Crear Modelo</button>
            </div>
          </form>
        </div>
      </div>

      <!-- Estilos adicionales -->
      <style>
        /* ========== SECCIONES DEL MODAL ========== */
        .modal-section {
          border-left: 4px solid #3b82f6;
          padding-left: 1rem;
          margin-bottom: 1.5rem;
        }
        
        .modal-section-title {
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #3b82f6;
          margin-bottom: 1rem;
        }

        /* ========== TRACTORES HEADER RESPONSIVE ========== */
        .tractores-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }

        .tractores-header-left {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .tractores-count {
          background: #e7f1ff;
          color: #0056b3;
          padding: 0.25rem 0.75rem;
          border-radius: 50px;
          font-size: 0.75rem;
          font-weight: 500;
          white-space: nowrap;
        }

        @media (max-width: 480px) {
          .tractores-header {
            flex-wrap: wrap;
          }
          
          .tractores-header-left {
            flex: 1;
            min-width: 100%;
            justify-content: space-between;
            margin-bottom: 0.5rem;
          }
          
          .tractores-header .btn-primary {
            width: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }

        /* ========== TRACTOR CARDS ========== */
        .tractor-card {
          border: 1px solid #e0e0e0;
          border-radius: 12px;
          margin-bottom: 0.75rem;
          overflow: hidden;
          transition: all 0.2s ease;
        }
        .tractor-card:hover {
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        .tractor-card.expanded {
          border-color: #0056b3;
          box-shadow: 0 0 0 2px rgba(0,86,179,0.2);
        }
        .tractor-card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          background: #fff;
          cursor: pointer;
        }
        .tractor-card-header:hover {
          background: #f8f9fa;
        }
        .tractor-card-info {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        .tractor-card-icon {
          width: 44px;
          height: 44px;
          background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
        }
        .tractor-card-title {
          font-weight: 600;
          color: #333;
        }
        .tractor-card-body {
          display: none;
          padding: 1rem;
          background: #f8f9fa;
          border-top: 1px solid #e0e0e0;
        }
        .tractor-card.expanded .tractor-card-body {
          display: block;
        }
        .tractor-card .chevron {
          transition: transform 0.2s ease;
          color: #999;
          font-size: 0.8rem;
        }
        .tractor-card.expanded .chevron {
          transform: rotate(180deg);
        }
        
        /* ========== RECUADRO SELECCIONAR MODELO ========== */
        .seleccionar-modelo-box {
          border: 1px solid #e0e0e0;
          border-radius: 10px;
          padding: 1rem;
          background: #f8fafc;
          margin-bottom: 1rem;
        }
        
        /* ========== BUTTONS ========== */
        .btn-icon {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0.5rem;
          border-radius: 6px;
          transition: all 0.2s;
          font-size: 1rem;
        }
        .btn-icon:hover {
          background: #f0f0f0;
        }
        .btn-icon.delete:hover {
          background: #fee;
          color: #c00;
        }
        
        /* Botón + Nuevo Modelo */
        .btn-nuevo-modelo {
          width: 38px;
          height: 38px;
          min-width: 38px;
          border: 2px dashed #0056b3;
          background: #f0f7ff;
          color: #0056b3;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.25rem;
          font-weight: 600;
          transition: all 0.2s ease;
        }
        .btn-nuevo-modelo:hover {
          background: #0056b3;
          color: white;
          border-style: solid;
          transform: scale(1.05);
        }

        /* ========== BOTÓN ELIMINAR TRACTOR MEJORADO ========== */
        .btn-eliminar-tractor {
          background: transparent;
          color: #999;
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          padding: 0.6rem 1.2rem;
          font-size: 0.85rem;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.2s ease;
        }
        
        .btn-eliminar-tractor:hover {
          color: #dc3545;
          border-color: #dc3545;
          background: #fff5f5;
        }
        
        .btn-eliminar-tractor:active {
          background: #dc3545;
          color: white;
          border-color: #dc3545;
        }
        
        /* ========== LABELS ========== */
        .section-label {
          font-size: 0.7rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #666;
          margin-bottom: 0.5rem;
        }
        
        /* ========== FORM GRIDS ========== */
        .req-form-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        /* ========== DETALLE REQUISICIÓN ========== */
        .req-detalle-info {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.75rem;
        }

        .req-tractor-card {
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 0.5rem;
        }

        .req-tractor-header {
          background: #f8f9fa;
          padding: 0.75rem 1rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .req-tractor-body {
          padding: 0.75rem 1rem;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.5rem;
          font-size: 0.9rem;
        }

        @media (max-width: 480px) {
          .req-detalle-info {
            grid-template-columns: 1fr;
          }
          .req-tractor-body {
            grid-template-columns: 1fr;
          }
          .req-form-grid {
            grid-template-columns: 1fr;
          }
        }

        /* ========== RESPONSIVE ========== */
        @media (max-width: 480px) {
          .btn-eliminar-tractor {
            width: 100%;
            justify-content: center;
            padding: 0.75rem 1rem;
          }
          
          .seleccionar-modelo-box {
            padding: 0.75rem;
          }
          
          /* Marca y Modelo en 2 columnas + botón */
          .seleccionar-modelo-grid {
            grid-template-columns: 1fr 1fr auto !important;
            gap: 0.5rem !important;
          }
          
          /* Año, Cantidad, Costo en 3 columnas compactas */
          .detalles-grid {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 0.5rem !important;
          }
          
          /* Reducir tamaño de fuente en inputs en móvil */
          .seleccionar-modelo-grid .form-select,
          .detalles-grid .form-input {
            font-size: 0.85rem;
            padding: 0.5rem;
          }
          
          /* Botón + más compacto */
          .btn-nuevo-modelo {
            width: 34px;
            height: 34px;
            min-width: 34px;
          }
          
          .modal-section {
            padding-left: 0.75rem;
          }
        }
      </style>
    `;
  },

  async afterRender() {
    window.requisicionesView = this;
    this.paginaActual = 1;
    this.limite = 10;
    this.detallesCount = 0;
    this.expandedCard = null;

    // Cargar datos iniciales
    await this.cargarEstadisticas();
    await this.cargarRequisiciones();
    await this.cargarDistribuidores();

    // Event listeners
    document.getElementById('tipoOrigen').addEventListener('change', (e) => {
      const distribuidorGroup = document.getElementById('distribuidorGroup');
      const distribuidorSelect = document.getElementById('distribuidorId');
      
      if (e.target.value === 'distribuidor') {
        distribuidorGroup.style.display = 'block';
        distribuidorSelect.required = true;
      } else {
        distribuidorGroup.style.display = 'none';
        distribuidorSelect.required = false;
        distribuidorSelect.value = '';
      }
    });

    document.getElementById('filtroEstado').addEventListener('change', () => this.cargarRequisiciones());
    document.getElementById('filtroPrioridad').addEventListener('change', () => this.cargarRequisiciones());
  },

  async cargarEstadisticas() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/requisiciones/estadisticas`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const result = await response.json();
        const stats = result.data?.estadisticas || [];

        document.getElementById('statPendientes').textContent = '0';
        document.getElementById('statRevision').textContent = '0';
        document.getElementById('statAprobadas').textContent = '0';
        document.getElementById('statOrdenGenerada').textContent = '0';

        stats.forEach(s => {
          if (s.estado === 'pendiente') document.getElementById('statPendientes').textContent = s.cantidad;
          if (s.estado === 'revision') document.getElementById('statRevision').textContent = s.cantidad;
          if (s.estado === 'aprobada') document.getElementById('statAprobadas').textContent = s.cantidad;
          if (s.estado === 'orden_generada') document.getElementById('statOrdenGenerada').textContent = s.cantidad;
        });
      }
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarRequisiciones() {
    try {
      const token = localStorage.getItem('accessToken');
      const estado = document.getElementById('filtroEstado').value;
      const prioridad = document.getElementById('filtroPrioridad').value;
      const busqueda = document.getElementById('filtroBusqueda').value;

      let url = `${window.API_BASE_URL}/requisiciones?page=${this.paginaActual}&limit=${this.limite}`;
      if (estado) url += `&estado=${estado}`;
      if (prioridad) url += `&prioridad=${prioridad}`;
      if (busqueda) url += `&search=${encodeURIComponent(busqueda)}`;

      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar requisiciones');

      const result = await response.json();
      this.renderTabla(result.data);

    } catch (error) {
      console.error('Error:', error);
      document.getElementById('requisicionesTableBody').innerHTML = `
        <tr><td colspan="9" style="text-align: center; color: red;">Error al cargar requisiciones</td></tr>
      `;
    }
  },

  renderTabla(data) {
    const tbody = document.getElementById('requisicionesTableBody');
    const requisiciones = data.requisiciones || [];

    if (requisiciones.length === 0) {
      tbody.innerHTML = '<tr><td colspan="9" style="text-align: center;">No hay requisiciones</td></tr>';
      return;
    }

    tbody.innerHTML = requisiciones.map(req => {
      const estadoHtml = this.renderEstado(req.estado);
      const prioridadHtml = this.renderPrioridad(req.prioridad);
      const accionesHtml = `
        <button class="btn btn-sm btn-info" onclick="window.requisicionesView.verDetalle(${req.id})" title="Ver">👁️</button>
        ${req.estado === 'pendiente' ? `
          <button class="btn btn-sm btn-warning" onclick="window.requisicionesView.cambiarEstado(${req.id}, 'revision')" title="Revisión">📝</button>
        ` : ''}
        ${req.estado === 'revision' ? `
          <button class="btn btn-sm btn-success" onclick="window.requisicionesView.cambiarEstado(${req.id}, 'aprobada')" title="Aprobar">✅</button>
          <button class="btn btn-sm btn-danger" onclick="window.requisicionesView.mostrarRechazo(${req.id})" title="Rechazar">❌</button>
        ` : ''}
        ${req.estado === 'aprobada' ? `
          <button class="btn btn-sm btn-primary" onclick="window.requisicionesView.generarOrdenCompra(${req.id})" title="Generar OC">📄</button>
        ` : ''}
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.requisicionesView.toggleRow(${req.id})">&#9654;</button></td>
        <td><strong>${req.folio}</strong></td>
        <td class="tbl-hide-mobile">${this.formatDate(req.fecha_requisicion)}</td>
        <td class="tbl-hide-mobile">${this.formatTipoOrigen(req.tipo_origen)}</td>
        <td class="tbl-hide-mobile">${req.solicitante_nombre || req.usuario_solicitante_nombre || '-'}</td>
        <td class="tbl-hide-mobile">${req.cantidad_items || 0}</td>
        <td class="tbl-hide-mobile">${prioridadHtml}</td>
        <td class="tbl-hide-mobile">${estadoHtml}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.25rem;">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-req-${req.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${this.formatDate(req.fecha_requisicion)}</dd>
            <dt>Origen</dt><dd>${this.formatTipoOrigen(req.tipo_origen)}</dd>
            <dt>Solicitante</dt><dd>${req.solicitante_nombre || req.usuario_solicitante_nombre || '-'}</dd>
            <dt>Items</dt><dd>${req.cantidad_items || 0}</dd>
            <dt>Prioridad</dt><dd>${prioridadHtml}</dd>
            <dt>Estado</dt><dd>${estadoHtml}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs); flex-wrap: wrap;">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-req-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  toggleDetalleRow(idx) {
    const detailRow = document.getElementById(`detail-reqdet-${idx}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  async cargarDistribuidores() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/personas/rol/distribuidor`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const result = await response.json();
        const select = document.getElementById('distribuidorId');
        (result.data?.personas || []).forEach(p => {
          const option = document.createElement('option');
          option.value = p.id;
          option.textContent = p.nombre_comercial || p.nombre_completo;
          select.appendChild(option);
        });
      }
    } catch (error) {
      console.error('Error al cargar distribuidores:', error);
    }
  },

  mostrarModalCrear() {
    document.getElementById('modalTitle').textContent = 'Nueva Requisición';
    document.getElementById('formRequisicion').reset();
    document.getElementById('detallesContainer').innerHTML = '';
    document.getElementById('distribuidorGroup').style.display = 'none';
    document.getElementById('distribuidorId').required = false;
    this.detallesCount = 0;
    this.expandedCard = null;
    this.actualizarContadorTractores();
    this.agregarDetalle();
    document.getElementById('modalRequisicion').style.display = 'flex';
  },

  cerrarModal() {
    document.getElementById('modalRequisicion').style.display = 'none';
  },

  // ========================================
  // Cards colapsables para tractores
  // ========================================

  agregarDetalle() {
    const container = document.getElementById('detallesContainer');
    const index = this.detallesCount++;

    const div = document.createElement('div');
    div.className = 'tractor-card expanded';
    div.id = `tractorCard_${index}`;
    div.dataset.index = index;

    div.innerHTML = `
      <!-- Header del card (siempre visible) -->
      <div class="tractor-card-header" onclick="window.requisicionesView.toggleCard(${index})">
        <div class="tractor-card-info">
          <div class="tractor-card-icon">🚜</div>
          <div class="tractor-card-title" id="cardTitle_${index}">Nuevo Tractor</div>
        </div>
        <span class="chevron">▼</span>
      </div>

      <!-- Body del card (formulario expandible) -->
      <div class="tractor-card-body">
        
        <!-- Recuadro: Seleccionar Modelo -->
        <div class="seleccionar-modelo-box">
          <div class="section-label">Seleccionar Modelo</div>
          <div class="seleccionar-modelo-grid" style="display: grid; grid-template-columns: 1fr 2fr auto; gap: 0.75rem; align-items: end;">
            <div class="form-group" style="margin-bottom: 0;">
              <label class="form-label required">Marca</label>
              <select name="marca_${index}" id="marca_${index}" class="form-select" required>
                <option value="">Cargando...</option>
              </select>
            </div>
            <div class="form-group" style="margin-bottom: 0;">
              <label class="form-label required">Modelo</label>
              <select name="modelo_${index}" id="modelo_${index}" class="form-select" required disabled>
                <option value="">Seleccione marca primero...</option>
              </select>
            </div>
            <div class="form-group" style="margin-bottom: 0;">
              <button type="button" class="btn-nuevo-modelo" onclick="window.requisicionesView.mostrarMiniModalModelo(${index})" title="Crear nuevo modelo">
                +
              </button>
            </div>
          </div>
        </div>

        <!-- Sección: Detalles -->
        <div class="section-label" style="margin-top: 0.5rem;">Detalles</div>
        <div class="detalles-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.75rem; margin-bottom: 0.75rem;">
          <div class="form-group" style="margin-bottom: 0;">
            <label class="form-label">Año</label>
            <input type="number" name="anio_${index}" class="form-input" min="2000" max="2030" placeholder="2025" />
          </div>
          <div class="form-group" style="margin-bottom: 0;">
            <label class="form-label required">Cantidad</label>
            <input type="number" name="cantidad_${index}" id="cantidad_${index}" class="form-input" min="1" value="1" required onchange="window.requisicionesView.actualizarContadorTractores()" />
          </div>
          <div class="form-group" style="margin-bottom: 0;">
            <label class="form-label">Costo Est. (USD)</label>
            <input type="number" name="costo_${index}" id="costo_${index}" class="form-input" step="0.01" min="0" placeholder="45000" style="background: #f5f5f5;" />
          </div>
        </div>

        <div class="form-group" style="margin-bottom: 0;">
          <label class="form-label">Especificaciones</label>
          <input type="text" name="specs_${index}" id="specs_${index}" class="form-input" placeholder="Auto-rellenado desde catálogo..." style="background: #f5f5f5;" />
        </div>

        <!-- Botón Eliminar mejorado -->
        <div style="border-top: 1px solid #eee; padding-top: 1rem; margin-top: 1.25rem; display: flex; justify-content: flex-end;">
          <button type="button" class="btn-eliminar-tractor" onclick="window.requisicionesView.eliminarDetalle(${index})">
            🗑️ Eliminar tractor
          </button>
        </div>
      </div>
    `;

    container.appendChild(div);

    // Colapsar cards anteriores
    this.colapsarOtrosCards(index);

    // Configurar cascada marca-modelo
    this.setupCascadaMarcaModelo(index);

    // Actualizar contador
    this.actualizarContadorTractores();
  },

  toggleCard(index) {
    const card = document.getElementById(`tractorCard_${index}`);
    if (!card) return;

    if (card.classList.contains('expanded')) {
      card.classList.remove('expanded');
      this.expandedCard = null;
    } else {
      this.colapsarOtrosCards(index);
      card.classList.add('expanded');
      this.expandedCard = index;
    }
  },

  colapsarOtrosCards(exceptIndex) {
    document.querySelectorAll('.tractor-card').forEach(card => {
      if (card.dataset.index != exceptIndex) {
        card.classList.remove('expanded');
      }
    });
  },

  eliminarDetalle(index) {
    const card = document.getElementById(`tractorCard_${index}`);
    if (card) {
      card.remove();
      this.actualizarContadorTractores();
    }
  },

  actualizarContadorTractores() {
    const cards = document.querySelectorAll('.tractor-card');
    let totalUnidades = 0;

    cards.forEach(card => {
      const index = card.dataset.index;
      const cantidadInput = document.getElementById(`cantidad_${index}`);
      if (cantidadInput) {
        totalUnidades += parseInt(cantidadInput.value) || 1;
      }
    });

    const countElement = document.getElementById('tractoresCount');
    if (countElement) {
      countElement.textContent = `${totalUnidades} unidad${totalUnidades !== 1 ? 'es' : ''}`;
    }
  },

  actualizarCardInfo(index) {
    const marcaSelect = document.getElementById(`marca_${index}`);
    const modeloSelect = document.getElementById(`modelo_${index}`);
    const titleEl = document.getElementById(`cardTitle_${index}`);

    const marca = marcaSelect?.value || '';
    const selectedOption = modeloSelect?.selectedOptions[0];
    
    // Obtener código y nombre del modelo desde data-modelo
    let codigoModelo = '';
    let nombreModelo = '';
    if (selectedOption && selectedOption.value) {
      try {
        const modeloData = JSON.parse(selectedOption.dataset.modelo);
        codigoModelo = modeloData.codigo || '';
        nombreModelo = modeloData.nombre || selectedOption.value;
      } catch (e) {
        nombreModelo = selectedOption.value;
      }
    }

    // Actualizar título: Código - Nombre (Marca)
    if (marca && nombreModelo) {
      const codigo = codigoModelo ? `${codigoModelo} - ` : '';
      titleEl.textContent = `${codigo}${nombreModelo} (${marca})`;
    } else {
      titleEl.textContent = 'Nuevo Tractor';
    }

    // Actualizar contador global
    this.actualizarContadorTractores();
  },

  async guardarRequisicion(event) {
    event.preventDefault();

    try {
      const form = document.getElementById('formRequisicion');
      const detalles = [];

      document.querySelectorAll('.tractor-card').forEach((item) => {
        const index = item.dataset.index;
        const marca = form.elements[`marca_${index}`]?.value;
        if (!marca) return;

        detalles.push({
          marca: marca,
          modelo: form.elements[`modelo_${index}`].value,
          anio: form.elements[`anio_${index}`].value ? parseInt(form.elements[`anio_${index}`].value) : null,
          cantidad: parseInt(form.elements[`cantidad_${index}`].value) || 1,
          costo_estimado_unitario: form.elements[`costo_${index}`].value ? parseFloat(form.elements[`costo_${index}`].value) : null,
          especificaciones_tecnicas: form.elements[`specs_${index}`].value || null
        });
      });

      if (detalles.length === 0) {
        this.mostrarAlerta('Debe agregar al menos un tractor', 'error');
        return;
      }

      const tipoOrigen = document.getElementById('tipoOrigen').value;
      const data = {
        tipo_origen: tipoOrigen,
        prioridad: document.getElementById('prioridad').value,
        fecha_requerida: document.getElementById('fechaRequerida').value || null,
        observaciones: document.getElementById('observaciones').value || null,
        detalles: detalles
      };

      const distribuidorId = document.getElementById('distribuidorId').value;
      if (tipoOrigen === 'distribuidor' && distribuidorId) {
        data.persona_solicitante_id = parseInt(distribuidorId);
      }

      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/requisiciones`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Error al crear requisición');
      }

      this.mostrarAlerta('Requisición creada exitosamente', 'success');
      this.cerrarModal();
      await this.cargarEstadisticas();
      await this.cargarRequisiciones();

    } catch (error) {
      console.error('Error:', error);
      this.mostrarAlerta(error.message, 'error');
    }
  },

  async verDetalle(id) {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/requisiciones/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar detalle');

      const result = await response.json();
      const req = result.data?.requisicion;

      document.getElementById('detalleContent').innerHTML = `
        <div style="display: grid; gap: 1rem;">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div><strong>Folio:</strong> ${req.folio}</div>
            <div><strong>Estado:</strong> ${this.renderEstado(req.estado)}</div>
            <div><strong>Fecha:</strong> ${this.formatDate(req.fecha_requisicion)}</div>
            <div><strong>Prioridad:</strong> ${this.renderPrioridad(req.prioridad)}</div>
            <div><strong>Tipo:</strong> ${this.formatTipoOrigen(req.tipo_origen)}</div>
            <div><strong>Fecha Requerida:</strong> ${req.fecha_requerida ? this.formatDate(req.fecha_requerida) : 'No especificada'}</div>
          </div>

          <hr style="margin: 1rem 0;" />

          <h4>Tractores Solicitados</h4>
          <table class="table" style="font-size: 0.9rem;">
            <thead>
              <tr>
                <th></th>
                <th>Marca</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Año</th>
                <th class="tbl-hide-mobile">Cant.</th>
                <th class="tbl-hide-mobile">Costo Est.</th>
              </tr>
            </thead>
            <tbody>
              ${(req.detalles || []).map((d, idx) => `
                <tr>
                  <td><button class="tbl-expand-btn" onclick="window.requisicionesView.toggleDetalleRow(${idx})">&#9654;</button></td>
                  <td><strong>${d.marca}</strong></td>
                  <td class="tbl-hide-mobile">${d.modelo}</td>
                  <td class="tbl-hide-mobile">${d.anio || '-'}</td>
                  <td class="tbl-hide-mobile">${d.cantidad}</td>
                  <td class="tbl-hide-mobile">${d.costo_estimado_unitario ? '$' + this.formatNumber(d.costo_estimado_unitario) + ' USD' : '-'}</td>
                </tr>
                <tr class="tbl-detail-row" id="detail-reqdet-${idx}">
                  <td colspan="6" class="tbl-detail-cell">
                    <dl class="tbl-detail-grid">
                      <dt>Modelo</dt><dd>${d.modelo}</dd>
                      <dt>Año</dt><dd>${d.anio || '-'}</dd>
                      <dt>Cantidad</dt><dd>${d.cantidad}</dd>
                      <dt>Costo Est.</dt><dd>${d.costo_estimado_unitario ? '$' + this.formatNumber(d.costo_estimado_unitario) + ' USD' : '-'}</dd>
                    </dl>
                  </td>
                </tr>
              `).join('')}
            </tbody>
          </table>

          ${req.observaciones ? `<div><strong>Observaciones:</strong> ${req.observaciones}</div>` : ''}
        </div>
      `;

      let actions = '<button class="btn btn-secondary" onclick="window.requisicionesView.cerrarModalDetalle()">Cerrar</button>';

      if (req.estado === 'aprobada') {
        actions = `
          <button class="btn btn-secondary" onclick="window.requisicionesView.cerrarModalDetalle()">Cerrar</button>
          <button class="btn btn-primary" onclick="window.requisicionesView.generarOrdenCompra(${req.id})">📄 Generar Orden de Compra</button>
        `;
      }

      document.getElementById('detalleActions').innerHTML = actions;
      document.getElementById('modalDetalle').style.display = 'flex';

    } catch (error) {
      console.error('Error:', error);
      this.mostrarAlerta('Error al cargar detalle', 'error');
    }
  },

  cerrarModalDetalle() {
    document.getElementById('modalDetalle').style.display = 'none';
  },

  async cambiarEstado(id, nuevoEstado, motivo = null) {
    try {
      const token = localStorage.getItem('accessToken');
      const body = { estado: nuevoEstado };
      if (motivo) body.motivo_rechazo = motivo;

      const response = await fetch(`${window.API_BASE_URL}/requisiciones/${id}/estado`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        const result = await response.json();
        throw new Error(result.message || 'Error al cambiar estado');
      }

      this.mostrarAlerta(`Requisición ${nuevoEstado} exitosamente`, 'success');
      await this.cargarEstadisticas();
      await this.cargarRequisiciones();

    } catch (error) {
      console.error('Error:', error);
      this.mostrarAlerta(error.message, 'error');
    }
  },

  mostrarRechazo(id) {
    const motivo = prompt('Motivo del rechazo:');
    if (motivo) {
      this.cambiarEstado(id, 'rechazada', motivo);
    }
  },

  generarOrdenCompra(requisicionId) {
    this.cerrarModalDetalle();
    router.navigate(`/compras/ordenes/nueva?requisicion=${requisicionId}`);
  },

  renderEstado(estado) {
    const estados = {
      'pendiente': '<span class="badge" style="background: #ffc107; color: #000;">Pendiente</span>',
      'revision': '<span class="badge" style="background: #17a2b8; color: #fff;">En Revisión</span>',
      'aprobada': '<span class="badge" style="background: #28a745; color: #fff;">Aprobada</span>',
      'rechazada': '<span class="badge" style="background: #dc3545; color: #fff;">Rechazada</span>',
      'orden_generada': '<span class="badge" style="background: #6f42c1; color: #fff;">OC Generada</span>',
      'completada': '<span class="badge" style="background: #6c757d; color: #fff;">Completada</span>'
    };
    return estados[estado] || estado;
  },

  renderPrioridad(prioridad) {
    const prioridades = {
      'urgente': '<span style="color: #dc3545; font-weight: bold;">🔴 Urgente</span>',
      'alta': '<span style="color: #fd7e14;">🟠 Alta</span>',
      'media': '<span style="color: #ffc107;">🟡 Media</span>',
      'baja': '<span style="color: #28a745;">🟢 Baja</span>'
    };
    return prioridades[prioridad] || prioridad;
  },

  formatTipoOrigen(tipo) {
    return tipo === 'distribuidor' ? '👤 Distribuidor' : '📦 Stock Almacén';
  },

  formatDate(dateString) {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('es-MX', {
      year: 'numeric', month: 'short', day: 'numeric'
    });
  },

  formatNumber(num) {
    return parseFloat(num).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  },

  mostrarAlerta(mensaje, tipo = 'info') {
    const div = document.createElement('div');
    div.style.cssText = `
      position: fixed; top: 20px; right: 20px; z-index: 9999;
      padding: 1rem 1.5rem; border-radius: 8px; color: white;
      background: ${tipo === 'success' ? '#28a745' : tipo === 'error' ? '#dc3545' : '#007bff'};
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;
    div.textContent = mensaje;
    document.body.appendChild(div);
    setTimeout(() => div.remove(), 3000);
  },

  // ========================================
  // FUNCIONES PARA CASCADA MARCA → MODELO
  // ========================================

  async setupCascadaMarcaModelo(index) {
    const marcaSelect = document.getElementById(`marca_${index}`);
    const modeloSelect = document.getElementById(`modelo_${index}`);
    const specsInput = document.getElementById(`specs_${index}`);
    const costoInput = document.getElementById(`costo_${index}`);

    // Cargar marcas
    await this.cargarMarcasParaDetalle(index);

    // Event: cuando cambia la marca
    marcaSelect.addEventListener('change', async (e) => {
      const marca = e.target.value;

      if (!marca) {
        modeloSelect.disabled = true;
        modeloSelect.innerHTML = '<option value="">Seleccione marca primero...</option>';
        specsInput.value = '';
        costoInput.value = '';
        this.actualizarCardInfo(index);
        return;
      }

      try {
        modeloSelect.disabled = true;
        modeloSelect.innerHTML = '<option value="">Cargando...</option>';

        const response = await modeloService.obtenerPorMarca(marca);
        const modelos = response.data?.modelos || response.modelos || [];

        modeloSelect.innerHTML = `
          <option value="">Seleccione modelo...</option>
          ${modelos.map(m => `
            <option value="${m.nombre}" data-modelo='${JSON.stringify(m)}'>
              ${m.codigo} - ${m.nombre}${m.linea ? ` · ${m.linea}` : ''}
            </option>
          `).join('')}
        `;

        modeloSelect.disabled = false;
        this.actualizarCardInfo(index);

      } catch (error) {
        console.error('Error al cargar modelos:', error);
        modeloSelect.innerHTML = '<option value="">Error al cargar</option>';
      }
    });

    // Event: cuando cambia el modelo
    modeloSelect.addEventListener('change', (e) => {
      const selectedOption = e.target.selectedOptions[0];

      if (!selectedOption || !selectedOption.value) {
        specsInput.value = '';
        costoInput.value = '';
        this.actualizarCardInfo(index);
        return;
      }

      try {
        const modeloData = JSON.parse(selectedOption.dataset.modelo);

        // Auto-rellenar especificaciones
        const specs = [];
        if (modeloData.hp) specs.push(`${modeloData.hp} HP`);
        if (modeloData.cilindros) specs.push(`${modeloData.cilindros} cilindros`);
        if (modeloData.traccion) specs.push(modeloData.traccion);
        if (modeloData.descripcion) specs.push(modeloData.descripcion);
        specsInput.value = specs.join(', ');

        // Auto-rellenar costo si existe
        if (modeloData.precio_base) {
          costoInput.value = modeloData.precio_base;
        }

        this.actualizarCardInfo(index);

      } catch (error) {
        console.error('Error al parsear modelo:', error);
      }
    });
  },

  async cargarMarcasParaDetalle(index) {
    const marcaSelect = document.getElementById(`marca_${index}`);

    try {
      const response = await modeloService.obtenerMarcas();
      const marcas = response.data?.marcas || response.marcas || [];

      marcaSelect.innerHTML = `
        <option value="">Seleccione...</option>
        ${marcas.map(marca => `<option value="${marca}">${marca}</option>`).join('')}
      `;

    } catch (error) {
      console.error('Error al cargar marcas:', error);
      marcaSelect.innerHTML = '<option value="">Error</option>';
    }
  },

  // ========================================
  // MINI-MODAL: CREAR MODELO INLINE
  // ========================================

  mostrarMiniModalModelo(detalleIndex) {
    this.miniModalDetalleIndex = detalleIndex;

    const marcaActual = document.getElementById(`marca_${detalleIndex}`)?.value || '';

    document.getElementById('miniModeloCodigo').value = '';
    document.getElementById('miniModeloNombre').value = '';
    document.getElementById('miniModeloMarca').value = marcaActual;
    document.getElementById('miniModeloHP').value = '';
    document.getElementById('miniModeloDescripcion').value = '';

    document.getElementById('miniModalModelo').style.display = 'flex';
    document.getElementById('miniModeloCodigo').focus();
  },

  cerrarMiniModalModelo() {
    document.getElementById('miniModalModelo').style.display = 'none';
    this.miniModalDetalleIndex = null;
  },

  async guardarNuevoModelo(event) {
    event.preventDefault();

    const data = {
      codigo: document.getElementById('miniModeloCodigo').value.trim(),
      nombre: document.getElementById('miniModeloNombre').value.trim(),
      marca: document.getElementById('miniModeloMarca').value,
      hp: document.getElementById('miniModeloHP').value ? parseInt(document.getElementById('miniModeloHP').value) : null,
      descripcion: document.getElementById('miniModeloDescripcion').value.trim() || null
    };

    try {
      const response = await modeloService.crear(data);
      const nuevoModelo = response.data || response;

      this.mostrarAlerta('Modelo creado exitosamente', 'success');
      this.cerrarMiniModalModelo();

      if (this.miniModalDetalleIndex !== null) {
        const index = this.miniModalDetalleIndex;
        const marcaSelect = document.getElementById(`marca_${index}`);
        const modeloSelect = document.getElementById(`modelo_${index}`);

        marcaSelect.value = nuevoModelo.marca;
        marcaSelect.dispatchEvent(new Event('change'));

        setTimeout(() => {
          const options = Array.from(modeloSelect.options);
          const modeloOption = options.find(opt => opt.value === nuevoModelo.nombre);

          if (modeloOption) {
            modeloSelect.value = nuevoModelo.nombre;
            modeloSelect.dispatchEvent(new Event('change'));
          }
        }, 500);
      }

    } catch (error) {
      console.error('Error al crear modelo:', error);
      this.mostrarAlerta(error.message || 'Error al crear modelo', 'error');
    }
  }
};